var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.56473V4.0006C22 2.5831 21.36 2.01007 19.77 2.01007H15.73C14.14 2.01007 13.5 2.5831 13.5 4.0006V8.55468C13.5 9.98223 14.14 10.5452 15.73 10.5452H19.77C21.36 10.5553 22 9.98223 22 8.56473Z",
    fill: "#BFC0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.8746V15.8131C22 14.2146 21.36 13.5712 19.77 13.5712H15.73C14.14 13.5712 13.5 14.2146 13.5 15.8131V19.8746C13.5 21.473 14.14 22.1164 15.73 22.1164H19.77C21.36 22.1164 22 21.473 22 19.8746Z",
    fill: "#BFC0C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.56473V4.0006C10.5 2.5831 9.86 2.01007 8.27 2.01007H4.23C2.64 2.01007 2 2.5831 2 4.0006V8.55468C2 9.98223 2.64 10.5452 4.23 10.5452H8.27C9.86 10.5553 10.5 9.98223 10.5 8.56473Z",
    fill: "#BFC0C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.8746V15.8131C10.5 14.2146 9.86 13.5712 8.27 13.5712H4.23C2.64 13.5712 2 14.2146 2 15.8131V19.8746C2 21.473 2.64 22.1164 4.23 22.1164H8.27C9.86 22.1164 10.5 21.473 10.5 19.8746Z",
    fill: "#BFC0C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.f01d2aedc20efda79d75bfcea1164701.svg";
export { ForwardRef as ReactComponent };